import RelatedReferrals from './RelatedReferrals';

export default RelatedReferrals;
